import { createApp } from '@app/adapters/create-app'
import SfAssistantChecksPage from '@app/application/sf-assistant-checks/components/sf-assistant-checks-page.vue'
import createInboxStore from '@app/application/communication/screens/inbox/store/inbox'

window.onDomLoad(function ($doc) {
  const element = $doc[0].querySelector(
    '[data-behaviour="sf-assistant-checks-page"]'
  ) as HTMLElement

  if (element) {
    const {
      workflow: contextId,
      category: initialCategory,
      search: initialSearch,
      item: initialItem,
    } = element.dataset ?? {}

    const app = createApp(
      SfAssistantChecksPage,
      { contextId, initialCategory, initialSearch, initialItem },
      { singletonId: 'sf-assistant-checks-page' }
    )

    const endpointParams = {
      companyId: window.Silverfin.currentCompanyId,
      ledgerId: window.Silverfin.currentLedgerId(),
      firmId: window.Silverfin.currentFirmId,
    }

    const store = createInboxStore(endpointParams)

    app.use(store)
    app.mount(element)
  }
})
